import { useGameStore } from '../state/gameStore';
import { PanelShell } from './PanelShell';

export function SettingsPanel() {
  const reduced = useGameStore((state) => state.reducedEffects);
  const setReduced = useGameStore((state) => state.setReducedEffects);
  const sound = useGameStore((state) => state.soundOn);
  const setSound = useGameStore((state) => state.setSoundOn);
  return (
    <PanelShell eyebrow="MAKE THE CHAOS BEHAVE" title="SETTINGS">
      <label className="toggle-row">
        <span>
          <strong>SOUND</strong>
          <small>Music and terminal abuse</small>
        </span>
        <input type="checkbox" checked={sound} onChange={(event) => setSound(event.target.checked)} />
      </label>
      <label className="toggle-row">
        <span>
          <strong>REDUCED EFFECTS</strong>
          <small>Less motion, shake, particles and GPU drama</small>
        </span>
        <input
          type="checkbox"
          checked={reduced}
          onChange={(event) => setReduced(event.target.checked)}
        />
      </label>
      <div className="control-help">
        <span>DESKTOP</span>
        <strong>WASD / ARROWS · SPACE</strong>
        <small>Move, dodge Bear Bots, and use your signature attack. The zone dock opens on-chain activities.</small>
      </div>
    </PanelShell>
  );
}
